import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { Reveal, staggerParent, staggerChild } from "./Reveal";

const PLACEHOLDERS = [
  { role: "Community Member" },
  { role: "Local Parent" },
  { role: "Education Advocate" },
];

export const Endorsements = () => {
  return (
    <section id="endorsements" className="py-20 lg:py-28 bg-white" data-testid="endorsements-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal>
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-teal-600">Endorsements</p>
          <h2 className="font-display font-extrabold tracking-tight text-slate-900 text-3xl md:text-4xl lg:text-5xl mt-3 max-w-2xl leading-tight">
            Support from across the community
          </h2>
          <p className="mt-4 text-slate-500 max-w-xl">
            Endorsements will be shared here as the campaign grows. Want to lend your voice?
            We'd love to hear from you.
          </p>
        </Reveal>

        <motion.div
          variants={staggerParent}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-60px" }}
          className="mt-14 grid md:grid-cols-3 gap-6"
        >
          {PLACEHOLDERS.map((p, i) => (
            <motion.div
              key={i}
              variants={staggerChild}
              className="rounded-2xl border border-dashed border-slate-300 bg-slate-50/60 p-8"
              data-testid={`endorsement-placeholder-${i}`}
            >
              <Quote size={30} className="text-teal-500/50" />
              <div className="mt-5 space-y-2.5" aria-hidden="true">
                <div className="h-3 rounded-full bg-slate-200 w-full" />
                <div className="h-3 rounded-full bg-slate-200 w-11/12" />
                <div className="h-3 rounded-full bg-slate-200 w-3/4" />
              </div>
              <div className="mt-7 flex items-center gap-3">
                <div className="h-11 w-11 rounded-full bg-slate-200" aria-hidden="true" />
                <div>
                  <div className="h-3 w-24 rounded-full bg-slate-300 mb-1.5" aria-hidden="true" />
                  <div className="text-sm text-slate-400 font-medium">{p.role}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
